export default {
  getApp: 'Get App',
};
